export function initVideoFacade() {
    const facade = document.querySelector('.sdcc-video__facade')
    if (!facade) return
  
    facade.addEventListener('click', () => {
      const videoId = facade.dataset.videoId
      const embedWrap = document.querySelector('.sdcc-video__embed-wrap')
  
      embedWrap.innerHTML = `
        <iframe
          src="https://www.youtube.com/embed/${videoId}?autoplay=1"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>`
  
      facade.style.display = 'none'
      embedWrap.style.display = 'block'
    })
  }